module.exports = __webpack_public_path__ + "img/list-pattern2.f6f4b7e.svg";